export class CalculateUtilizationFactorDto {
  Id: number;
  HasKnot: boolean;
  MblRopes?: number;
  MblSinkRopes?: number;
  MblStraps?: number;
  MblChainShackleConnectionPlates?: number;
  MblUsedChainRopeWithKnot?: number;
  MblAnchoring?: number;
  UtilizationFactor?: number;
}

export enum MooringStep {
  ANCHOR_LINE,
  GRID_LINE,
  BUOY,
  BRIDLE,
  FLEET_ANCHOR_LINE,
}
